import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, ProtectedRoute, useAuth } from "@/lib/auth";
import Layout from "@/components/Layout";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Products from "@/pages/Products";
import Warehouses from "@/pages/Warehouses";
import Users from "@/pages/Users";
import Stock from "@/pages/Stock";
import { RequestList, RequestNew, RequestDetail } from "@/pages/Requests";
import Recoveries from "@/pages/Recoveries";
import Dispatches from "@/pages/Dispatches";
import { ProjectsList, ProjectDetail } from "@/pages/Projects";
import Reports from "@/pages/Reports";
import AuditLog from "@/pages/AuditLog";
import ExcelImport from "@/pages/ExcelImport";
import MyMaterial from "@/pages/MyMaterial";
import Serials from "@/pages/Serials";
import Settings from "@/pages/Settings";
import StockDetail from "@/pages/StockDetail";
import RecoveryDetail from "@/pages/RecoveryDetail";

function RoleGate({ roles, children }) {
  const { user } = useAuth();
  if (user && roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function ShellRoutes() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/requests" element={<RequestList />} />
        <Route path="/requests/new" element={<RequestNew />} />
        <Route path="/requests/:id" element={<RequestDetail />} />
        <Route path="/products" element={<RoleGate roles={["admin","cluster_head"]}><Products /></RoleGate>} />
        <Route path="/warehouses" element={<RoleGate roles={["admin"]}><Warehouses /></RoleGate>} />
        <Route path="/users" element={<RoleGate roles={["admin","cluster_head"]}><Users /></RoleGate>} />
        <Route path="/stock" element={<RoleGate roles={["admin","cluster_head","warehouse_manager"]}><Stock /></RoleGate>} />
        <Route path="/stock/detail/:warehouseId/:productId" element={<RoleGate roles={["admin","cluster_head","warehouse_manager"]}><StockDetail /></RoleGate>} />
        <Route path="/serials" element={<RoleGate roles={["admin","cluster_head","warehouse_manager"]}><Serials /></RoleGate>} />
        <Route path="/recoveries" element={<Recoveries />} />
        <Route path="/recoveries/:id" element={<RecoveryDetail />} />
        <Route path="/dispatches" element={<RoleGate roles={["admin","warehouse_manager"]}><Dispatches /></RoleGate>} />
        <Route path="/settings" element={<RoleGate roles={["admin"]}><Settings /></RoleGate>} />
        <Route path="/projects" element={<ProjectsList />} />
        <Route path="/projects/:id" element={<ProjectDetail />} />
        <Route path="/reports" element={<RoleGate roles={["admin","cluster_head"]}><Reports /></RoleGate>} />
        <Route path="/excel" element={<RoleGate roles={["admin"]}><ExcelImport /></RoleGate>} />
        <Route path="/audit" element={<RoleGate roles={["admin"]}><AuditLog /></RoleGate>} />
        <Route path="/issues" element={<MyMaterial />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/*" element={<ProtectedRoute><ShellRoutes /></ProtectedRoute>} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
